// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export const SET_ONBOARDING_CLUSTER_SETUP = 'onboarding/SET_ONBOARDING_CLUSTER_SETUP';